/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatisticsSPD
 */
export interface StatisticsSPD {
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseInThisYearCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseInLast30DaysCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examOpenCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    judgmentsCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    judgmentsInThisYearCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    judgmentsInLast30DaysCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseStandardCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseStandardInThisYearCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseStandardInLast30DaysCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseOnlineCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseOnlineInThisYearCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseOnlineInLast30DaysCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseExternalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseExternalInThisYearCounts: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsSPD
     */
    examCloseExternalInLast30DaysCounts: number;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumFinishedPayments: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumReturnedPayments: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumFinishedPaymentsInThisYear: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumReturnedPaymentsInThisYear: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumFinishedPaymentsInLast30Days: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumReturnedPaymentsInLast30Days: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumIssuedInvoices: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumPaidInvoices: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumIssuedInvoicesInThisYear: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumPaidInvoicesInThisYear: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumIssuedInvoicesInLast30Days: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumPaidInvoicesInLast30Days: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumIssuedReceipts: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumIssuedReceiptsInThisYear: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsSPD
     */
    sumIssuedReceiptsInLast30Days: string;
}

/**
 * Check if a given object implements the StatisticsSPD interface.
 */
export function instanceOfStatisticsSPD(value: object): value is StatisticsSPD {
    if (!('examCloseCounts' in value) || value['examCloseCounts'] === undefined) return false;
    if (!('examCloseInThisYearCounts' in value) || value['examCloseInThisYearCounts'] === undefined) return false;
    if (!('examCloseInLast30DaysCounts' in value) || value['examCloseInLast30DaysCounts'] === undefined) return false;
    if (!('examOpenCounts' in value) || value['examOpenCounts'] === undefined) return false;
    if (!('judgmentsCounts' in value) || value['judgmentsCounts'] === undefined) return false;
    if (!('judgmentsInThisYearCounts' in value) || value['judgmentsInThisYearCounts'] === undefined) return false;
    if (!('judgmentsInLast30DaysCounts' in value) || value['judgmentsInLast30DaysCounts'] === undefined) return false;
    if (!('examCloseStandardCounts' in value) || value['examCloseStandardCounts'] === undefined) return false;
    if (!('examCloseStandardInThisYearCounts' in value) || value['examCloseStandardInThisYearCounts'] === undefined) return false;
    if (!('examCloseStandardInLast30DaysCounts' in value) || value['examCloseStandardInLast30DaysCounts'] === undefined) return false;
    if (!('examCloseOnlineCounts' in value) || value['examCloseOnlineCounts'] === undefined) return false;
    if (!('examCloseOnlineInThisYearCounts' in value) || value['examCloseOnlineInThisYearCounts'] === undefined) return false;
    if (!('examCloseOnlineInLast30DaysCounts' in value) || value['examCloseOnlineInLast30DaysCounts'] === undefined) return false;
    if (!('examCloseExternalCounts' in value) || value['examCloseExternalCounts'] === undefined) return false;
    if (!('examCloseExternalInThisYearCounts' in value) || value['examCloseExternalInThisYearCounts'] === undefined) return false;
    if (!('examCloseExternalInLast30DaysCounts' in value) || value['examCloseExternalInLast30DaysCounts'] === undefined) return false;
    if (!('sumFinishedPayments' in value) || value['sumFinishedPayments'] === undefined) return false;
    if (!('sumReturnedPayments' in value) || value['sumReturnedPayments'] === undefined) return false;
    if (!('sumFinishedPaymentsInThisYear' in value) || value['sumFinishedPaymentsInThisYear'] === undefined) return false;
    if (!('sumReturnedPaymentsInThisYear' in value) || value['sumReturnedPaymentsInThisYear'] === undefined) return false;
    if (!('sumFinishedPaymentsInLast30Days' in value) || value['sumFinishedPaymentsInLast30Days'] === undefined) return false;
    if (!('sumReturnedPaymentsInLast30Days' in value) || value['sumReturnedPaymentsInLast30Days'] === undefined) return false;
    if (!('sumIssuedInvoices' in value) || value['sumIssuedInvoices'] === undefined) return false;
    if (!('sumPaidInvoices' in value) || value['sumPaidInvoices'] === undefined) return false;
    if (!('sumIssuedInvoicesInThisYear' in value) || value['sumIssuedInvoicesInThisYear'] === undefined) return false;
    if (!('sumPaidInvoicesInThisYear' in value) || value['sumPaidInvoicesInThisYear'] === undefined) return false;
    if (!('sumIssuedInvoicesInLast30Days' in value) || value['sumIssuedInvoicesInLast30Days'] === undefined) return false;
    if (!('sumPaidInvoicesInLast30Days' in value) || value['sumPaidInvoicesInLast30Days'] === undefined) return false;
    if (!('sumIssuedReceipts' in value) || value['sumIssuedReceipts'] === undefined) return false;
    if (!('sumIssuedReceiptsInThisYear' in value) || value['sumIssuedReceiptsInThisYear'] === undefined) return false;
    if (!('sumIssuedReceiptsInLast30Days' in value) || value['sumIssuedReceiptsInLast30Days'] === undefined) return false;
    return true;
}

export function StatisticsSPDFromJSON(json: any): StatisticsSPD {
    return StatisticsSPDFromJSONTyped(json, false);
}

export function StatisticsSPDFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsSPD {
    if (json == null) {
        return json;
    }
    return {
        
        'examCloseCounts': json['examCloseCounts'],
        'examCloseInThisYearCounts': json['examCloseInThisYearCounts'],
        'examCloseInLast30DaysCounts': json['examCloseInLast30DaysCounts'],
        'examOpenCounts': json['examOpenCounts'],
        'judgmentsCounts': json['judgmentsCounts'],
        'judgmentsInThisYearCounts': json['judgmentsInThisYearCounts'],
        'judgmentsInLast30DaysCounts': json['judgmentsInLast30DaysCounts'],
        'examCloseStandardCounts': json['examCloseStandardCounts'],
        'examCloseStandardInThisYearCounts': json['examCloseStandardInThisYearCounts'],
        'examCloseStandardInLast30DaysCounts': json['examCloseStandardInLast30DaysCounts'],
        'examCloseOnlineCounts': json['examCloseOnlineCounts'],
        'examCloseOnlineInThisYearCounts': json['examCloseOnlineInThisYearCounts'],
        'examCloseOnlineInLast30DaysCounts': json['examCloseOnlineInLast30DaysCounts'],
        'examCloseExternalCounts': json['examCloseExternalCounts'],
        'examCloseExternalInThisYearCounts': json['examCloseExternalInThisYearCounts'],
        'examCloseExternalInLast30DaysCounts': json['examCloseExternalInLast30DaysCounts'],
        'sumFinishedPayments': json['sumFinishedPayments'],
        'sumReturnedPayments': json['sumReturnedPayments'],
        'sumFinishedPaymentsInThisYear': json['sumFinishedPaymentsInThisYear'],
        'sumReturnedPaymentsInThisYear': json['sumReturnedPaymentsInThisYear'],
        'sumFinishedPaymentsInLast30Days': json['sumFinishedPaymentsInLast30Days'],
        'sumReturnedPaymentsInLast30Days': json['sumReturnedPaymentsInLast30Days'],
        'sumIssuedInvoices': json['sumIssuedInvoices'],
        'sumPaidInvoices': json['sumPaidInvoices'],
        'sumIssuedInvoicesInThisYear': json['sumIssuedInvoicesInThisYear'],
        'sumPaidInvoicesInThisYear': json['sumPaidInvoicesInThisYear'],
        'sumIssuedInvoicesInLast30Days': json['sumIssuedInvoicesInLast30Days'],
        'sumPaidInvoicesInLast30Days': json['sumPaidInvoicesInLast30Days'],
        'sumIssuedReceipts': json['sumIssuedReceipts'],
        'sumIssuedReceiptsInThisYear': json['sumIssuedReceiptsInThisYear'],
        'sumIssuedReceiptsInLast30Days': json['sumIssuedReceiptsInLast30Days'],
    };
}

export function StatisticsSPDToJSON(value?: StatisticsSPD | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'examCloseCounts': value['examCloseCounts'],
        'examCloseInThisYearCounts': value['examCloseInThisYearCounts'],
        'examCloseInLast30DaysCounts': value['examCloseInLast30DaysCounts'],
        'examOpenCounts': value['examOpenCounts'],
        'judgmentsCounts': value['judgmentsCounts'],
        'judgmentsInThisYearCounts': value['judgmentsInThisYearCounts'],
        'judgmentsInLast30DaysCounts': value['judgmentsInLast30DaysCounts'],
        'examCloseStandardCounts': value['examCloseStandardCounts'],
        'examCloseStandardInThisYearCounts': value['examCloseStandardInThisYearCounts'],
        'examCloseStandardInLast30DaysCounts': value['examCloseStandardInLast30DaysCounts'],
        'examCloseOnlineCounts': value['examCloseOnlineCounts'],
        'examCloseOnlineInThisYearCounts': value['examCloseOnlineInThisYearCounts'],
        'examCloseOnlineInLast30DaysCounts': value['examCloseOnlineInLast30DaysCounts'],
        'examCloseExternalCounts': value['examCloseExternalCounts'],
        'examCloseExternalInThisYearCounts': value['examCloseExternalInThisYearCounts'],
        'examCloseExternalInLast30DaysCounts': value['examCloseExternalInLast30DaysCounts'],
        'sumFinishedPayments': value['sumFinishedPayments'],
        'sumReturnedPayments': value['sumReturnedPayments'],
        'sumFinishedPaymentsInThisYear': value['sumFinishedPaymentsInThisYear'],
        'sumReturnedPaymentsInThisYear': value['sumReturnedPaymentsInThisYear'],
        'sumFinishedPaymentsInLast30Days': value['sumFinishedPaymentsInLast30Days'],
        'sumReturnedPaymentsInLast30Days': value['sumReturnedPaymentsInLast30Days'],
        'sumIssuedInvoices': value['sumIssuedInvoices'],
        'sumPaidInvoices': value['sumPaidInvoices'],
        'sumIssuedInvoicesInThisYear': value['sumIssuedInvoicesInThisYear'],
        'sumPaidInvoicesInThisYear': value['sumPaidInvoicesInThisYear'],
        'sumIssuedInvoicesInLast30Days': value['sumIssuedInvoicesInLast30Days'],
        'sumPaidInvoicesInLast30Days': value['sumPaidInvoicesInLast30Days'],
        'sumIssuedReceipts': value['sumIssuedReceipts'],
        'sumIssuedReceiptsInThisYear': value['sumIssuedReceiptsInThisYear'],
        'sumIssuedReceiptsInLast30Days': value['sumIssuedReceiptsInLast30Days'],
    };
}

